import React, { FC } from 'react';
import Loading, { LoadingProps } from '@m4b-design/loading';
import cx from 'classnames';

import styles from './index.scss';

export const Spin: FC<
  LoadingProps & {
    loading?: boolean;
  }
> = props => {
  const { className, loading } = props;
  return (
    <Loading
      {...props}
      className={cx(className, {
        [styles.ecomSpin]: loading
      })}
    />
  );
};
